// src/redux/actions/admin-dashboard/AdminDashboardActions.js
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILURE = "FETCH_DASHBOARD_STATS_FAILURE";

export const FETCH_BENEFICIARY_STATS_REQUEST =
  "FETCH_BENEFICIARY_STATS_REQUEST";
export const FETCH_BENEFICIARY_STATS_SUCCESS =
  "FETCH_BENEFICIARY_STATS_SUCCESS";
export const FETCH_BENEFICIARY_STATS_FAILURE =
  "FETCH_BENEFICIARY_STATS_FAILURE";

export const FETCH_SURVEY_STATS_REQUEST = "FETCH_SURVEY_STATS_REQUEST";
export const FETCH_SURVEY_STATS_SUCCESS = "FETCH_SURVEY_STATS_SUCCESS";
export const FETCH_SURVEY_STATS_FAILURE = "FETCH_SURVEY_STATS_FAILURE";

// Fetch Dashboard Stats
export const fetchDashboardStats = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/dashboard/stats`,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_DASHBOARD_STATS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_DASHBOARD_STATS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_DASHBOARD_STATS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch dashboard stats",
    );
    throw error;
  }
};

// Fetch Beneficiary Stats
export const fetchBeneficiaryStats =
  (districtId = null, municipalityId = null) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BENEFICIARY_STATS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let url = `${BASE_URL}/v1/api/admin/dashboard/beneficiary-stats`;
      const params = new URLSearchParams();
      if (districtId) params.append("district_id", districtId);
      if (municipalityId) params.append("municipality_id", municipalityId);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { authorization: token },
      });

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_BENEFICIARY_STATS_SUCCESS,
          payload: {
            details: response.data.data.details || [],
            summary: response.data.data.summary || {},
            demographics: response.data.data.demographics || {},
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_BENEFICIARY_STATS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_BENEFICIARY_STATS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message ||
          "Failed to fetch beneficiary stats",
      );
      throw error;
    }
  };

// Fetch Survey Stats
export const fetchSurveyStats = () => async (dispatch) => {
  dispatch({ type: FETCH_SURVEY_STATS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/dashboard/survey-stats`,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_SURVEY_STATS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_SURVEY_STATS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_SURVEY_STATS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch survey stats",
    );
    throw error;
  }
};
